import { lt } from '@mews/framework';
import { Button, IconName } from '@optimus-web/core';
import { useSteppedDialogForm } from '@mews-commander/form';
import { OptimusProvider } from '@mews-commander/ui';
import { WithAccountId } from '@mews-commander/types';
import { DataTestId } from '@mews-commander/enums';
import { CreatePaymentPlanDialogSteppedForm } from './CreatePaymentPlanDialogSteppedForm';
import { CreatePaymentPlanFormStep } from './types';

export const CreatePaymentPlanAction = ({ accountId }: WithAccountId) => {
    const [createSteppedPaymentPlanDialog, toggleSteppedCreatePaymentPlanDialog] =
        useSteppedDialogForm<CreatePaymentPlanFormStep>({
            title: lt('CreatePaymentPlanDialogFormTitle'),
            renderForm: (props) => <CreatePaymentPlanDialogSteppedForm accountId={accountId} {...props} />,
            steps: ['planDetails', 'firstPayment', 'summary'],
            stepLabels: {
                planDetails: lt('CreatePaymentPlanFormStepLabelPlanDetails'),
                firstPayment: lt('CreatePaymentPlanFormStepLabelFirstPayment'),
                summary: lt('CreatePaymentPlanFormStepLabelSummary'),
            },
            saveLabel: lt('CreatePaymentPlanDialogSaveLabel'),
            suspenseLoader: 'overlay',
            submitButtonDataTestId: DataTestId.CreatePaymentPlanSubmitButton,
        });

    return (
        <>
            <Button
                icon={IconName.Add}
                onClick={() => toggleSteppedCreatePaymentPlanDialog()}
                data-test-create-payment-plan="action-button"
                type="submit"
            >
                {lt('PaymentPlansTableActionButtonTitle')}
            </Button>
            <OptimusProvider density="spacious">{createSteppedPaymentPlanDialog()}</OptimusProvider>
        </>
    );
};
